import React, { useMemo, useCallback } from "react";
import styles from "./mobile-menu.module.scss";
import DownLtLogoBlue from "@svgIcons/DownIt";
import menuItemData from "@/data/menu-items.json";
import Link from "next/link";
import MenuCTA from "./MenuCTA";

interface MenuItem {
  enabled: boolean;
  Item: {
    text: string;
    url?: string;
  };
  SubItem?: Array<unknown>;
}

const MenuItemComponent: React.FC<{
  item: MenuItem;
  onClick: () => void;
}> = React.memo(({ item, onClick }) => {
  const handleClick = useCallback(() => {
    onClick();
  }, [onClick]);

  const onNavigateHandler = (link) => {

    if(link.includes("career-services")){
      window.webengage.track("Career Advice Clicked")
    } else if(link.includes("amity-online-advantage")){
      window.webengage.track("Advantages Clicked")
    }
  }

  if (item.Item.url) {
    return (
      <Link onClick={()=> onNavigateHandler(item.Item.url)}  href={item.Item.url} className={styles.menuItem}>
        {item.Item.text}
        {!!item.SubItem?.length && <DownLtLogoBlue />}
      </Link>
    );
  }

  return (
    <div
      className={styles.menuItem}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && handleClick()}
    >
      {item.Item.text}
      {!!item.SubItem?.length && <DownLtLogoBlue />}
    </div>
  );
});

interface FilteredMenuItemsProps {
  onMenuItemClick: (pageValue: number) => void;
  showMenuItem: boolean;
  isSponsoredCertificates?: boolean;
}

const MenuItems: React.FC<FilteredMenuItemsProps> = React.memo(
  ({ onMenuItemClick, showMenuItem, isSponsoredCertificates }) => {
    const filteredMenuItems = useMemo(() => {
      return menuItemData
        .filter((item) => item.enabled)
        .map((item, index) => (
          <MenuItemComponent
            key={index}
            item={item}
            onClick={() => onMenuItemClick(1)}
          />
        ));
    }, [onMenuItemClick]);

    return (
      <div
        className={`${styles.menuItemWrapper} ${
          showMenuItem ? styles.open : ""
        }`}
      >
        <div>{filteredMenuItems}</div>
        <MenuCTA
        isSponsoredCertificates={isSponsoredCertificates}
      />
      </div>
    );
  }
);

export default MenuItems;
